export const ADD_EXPENSE_TYPE_REQUEST = 'ADD_EXPENSE_TYPE_REQUEST'
export const ADD_EXPENSE_TYPE_SUCCESS = 'ADD_EXPENSE_TYPE_SUCCESS'
export const ADD_EXPENSE_TYPE_FALIURE = 'ADD_EXPENSE_TYPE_FALIURE'
